export const environment = {
    environment: 'staging',
    apiUrl: 'https://cplhydrotest-v2-api-test1.azure.chevron.com/api/',
    calSettings: {
        "autoSignIn": true,
        "popupForLogin": false,
        "cacheLocation": "localStorage",
        "instance": "https://login.microsoftonline.com/",
        "tenantId": "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
        "clientId": "84e52882-e2a2-435d-8d0a-681f78f0f1e5",
        "redirectUri": "https://cplhydrotest-v2-test1.azure.chevron.com/",
        "oidcScopes": [
            "openid",
            "profile",
            "email",
            "offline_access"
        ],
        // API access scopes
        "apiScopes": [
            "openid",
            "profile",
            "email",
            "offline_access",
            "https://cplhydrotest-test.azure.chevron.com/user_impersonation"
        ],
        "graphScopes": [],
   },
    powerBi: {
        powerBiScopes: ["https://analysis.windows.net/powerbi/api/.default"], // not required in call Auth
        apiBase: 'https://api.powerbi.com/v1.0/myorg/groups'
    }
};
